import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ObterPaginaJornalPorAutenticidadeState } from "../../reducers/Autenticidade/obter-pagina-jornal-por-autenticidade.reducer";

export const selectObterPaginaJornalPorAutenticidadeState = createFeatureSelector<ObterPaginaJornalPorAutenticidadeState>('obterPaginaJornalPorAutenticidade');

export const selectDadosObterPaginaJornalPorAutenticidade = createSelector(
    selectObterPaginaJornalPorAutenticidadeState,
    (state: ObterPaginaJornalPorAutenticidadeState) => state.response
);

export const selectObterPaginaJornalPorAutenticidade = createSelector(
  selectObterPaginaJornalPorAutenticidadeState,
  (state: ObterPaginaJornalPorAutenticidadeState) => state
);

export const selectErrosObterPaginaJornalPorAutenticidade = createSelector(
    selectObterPaginaJornalPorAutenticidadeState,
    (state: ObterPaginaJornalPorAutenticidadeState) => state.error
);
